import { defineStore } from "pinia";
import axios from "axios";

export const products = defineStore("products", {
  state: () => ({
    flashDeals: [],
    newPro: [],
    freshFood: [],
    single: "",
    categorys: [
      {
        title: "Furniture",
        route: "all product",
      },
      {
        title: "groceries",
        route: "hossam",
      },
      {
        title: "WomenClothing",
        route: "ammar",
      },
      {
        title: "Electronics",
        route: "hamed",
      },
      {
        title: "smartphones",
        route: "kasme",
      },
    ],
  }),
  actions: {
    async getProducts() {
      await axios.get("https://dummyjson.com/products").then((res) => {
        res.data.products.forEach((e) => {
          e.wishlist = false;
        });
        this.newPro = res.data.products.filter(
          (el) => el.category === "furniture"
        );
        this.freshFood = res.data.products.filter(
          (el) => el.category === "groceries"
        );
        this.flashDeals = res.data.products.slice(0, 10);
      });
      console.log(this.flashDeals);
    },
    async getSinglePro(productId) {
      await axios
        .get(`https://dummyjson.com/products/${productId}`)
        .then((res) => {
          console.log(res.data);
          this.single = res.data;
          this.single.wishlist = false;
        });
    },
  },
});
